var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTwitterIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 19",
    style: {
      enableBackground: "new 0 0 24 19"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Web"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Webbsite-1.0",
    transform: "translate(-107.000000, -977.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    className: "st0",
    d: "M128.1,981.9c0,0.2,0,0.4,0,0.6c0,6.2-4.7,13.4-13.4,13.4c-2.7,0-5.1-0.8-7.2-2.1 c0.4,0,0.7,0.1,1.1,0.1c2.2,0,4.2-0.8,5.9-2c-2.1,0-3.8-1.4-4.4-3.3c0.3,0.1,0.6,0.1,0.9,0.1c0.4,0,0.8-0.1,1.2-0.2 c-2.2-0.4-3.8-2.3-3.8-4.6c0,0,0,0,0-0.1c0.6,0.4,1.4,0.6,2.1,0.6c-1.3-0.8-2.1-2.3-2.1-3.9c0-0.9,0.2-1.7,0.6-2.4 c2.3,2.9,5.8,4.7,9.7,4.9c-0.1-0.3-0.1-0.7-0.1-1.1c0-2.6,2.1-4.7,4.7-4.7c1.4,0,2.6,0.6,3.4,1.5c1.1-0.2,2.1-0.6,3-1.1 c-0.4,1.1-1.1,2-2.1,2.6c1-0.1,1.9-0.4,2.7-0.7C129.9,980.4,129.1,981.3,128.1,981.9z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterIcon);
export default __webpack_public_path__ + "static/media/twitter_icon.043a09824ba3b3a1988134bbdfdbf582.svg";
export { ForwardRef as ReactComponent };